import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import ListItem from "@material-ui/core/ListItem";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "./StudentCard.css";
import Profile from "./Profile/Profile";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";
import Address from "./Address/Address";
import Parents from "./Parents/Parents";

class StudentCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navValue: "General",
    };
  }

  handleNav = (e, value) => {
    this.setState({
      navValue: value,
    });
  };

  showNav = (val) => {
    switch (val) {
      case "General":
        return <Profile student={this.props.student} />;
      case "Address":
        return <Address student={this.props.student} />;
      case "Parents":
        return <Parents student={this.props.student} />;
      default:
        break;
    }
  };

  render() {
    const { classes, student } = this.props;
    return (
      <Fragment>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Paper className={classes.paper}>
            <div>
              <img
                src={`${publicImageUrl}/${student.image}`}
                alt={student.firstName}
                style={{ width: 150, height: 150 }}
              />
            </div>
            <div style={{ fontSize: 24 }}>
              {student.firstName} {student.middleName} {student.lastName}
            </div>
            <ListItem divider classes={{ divider: classes.dividerStyle }}>
              <b style={{ flexGrow: 1 }}>Admission No.</b>
              <div>{student.admissionId}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Batch</b>
              <div>{student.currentSession}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Class</b>
              <div>{student.studentClass}</div>
            </ListItem>
            {student.faculty && (
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Faculty</b>
                <div>{student.faculty}</div>
              </ListItem>
            )}
            {student.group && (
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Group</b>
                <div>{student.group}</div>
              </ListItem>
            )}
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Shift</b>
              <div>{student.shift}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Roll Number</b>
              <div>{student.roll}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Section</b>
              <div>{student.section}</div>
            </ListItem>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} xl={8} lg={8}>
          <Paper className={classes.paper}>
            <BottomNavigation
              value={this.state.navValue}
              onChange={(e, val) => this.handleNav(e, val)}
              showLabels
              style={{
                width: "100%",
                borderRadius: 25,
                backgroundColor: "#eee",
              }}
            >
              <BottomNavigationAction
                label="General"
                value="General"
                classes={{
                  root: classes.bottomRoot,
                  selected: classes.bottom,
                  label: classes.navLabel,
                }}
              />
              <BottomNavigationAction
                label="Address"
                value="Address"
                classes={{
                  root: classes.bottomRoot,
                  selected: classes.bottom,
                  label: classes.navLabel,
                }}
              />
              <BottomNavigationAction
                label="Parents"
                value="Parents"
                classes={{
                  root: classes.bottomRoot,
                  selected: classes.bottom,
                  label: classes.navLabel,
                }}
              />
            </BottomNavigation>
            {this.showNav(this.state.navValue)}
          </Paper>
        </Grid>
      </Fragment>
    );
  }
}

export default withStyles(useStyles)(StudentCard);
